import { getAzureContractsData } from '../../../api/azure/index'
import { getGCPContractsData } from '../../../api/gcp/index'
import { getContractsData } from '../../../api/marketplace/index'
import type { CloudMarketplace } from '../../productsListing/types'

export const getAPIBasedOnCloud = async (
  partnerId: string,
  productId: string,
  cloud: CloudMarketplace,
  contractId?: string
) => {
  switch (cloud) {
    case 'AWS': {
      if (contractId) return getContractsData(partnerId, productId, contractId)
      return getContractsData(partnerId, productId)
    }
    case 'AZURE': {
      return getAzureContractsData(partnerId, productId)
    }
    case 'GCP': {
      return getGCPContractsData({ partnerId, productId })
    }
  }
}
